var map = {
	"./avito.svg": "49a7",
	"./fb-messenger.svg": "43cd",
	"./fb.svg": "a963",
	"./ok.svg": "578d",
	"./phone.svg": "974d",
	"./sms.svg": "a84e",
	"./tg.svg": "62d9",
	"./vb.svg": "28d9",
	"./vk.svg": "3ab6",
	"./wa.svg": "8663",
	"./wechat.svg": "51cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8486";